import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "prefix"
    }, [h("d2-bar-cell", [h("d2-button", {
      "attrs": {
        "type": "primary",
        "icon": "el-icon-arrow-left",
        "label": "返回字典列表",
        "to": "/management/dict",
        "plain": true
      }
    })])]), h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.dictValueType !== 0 && this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : undefined]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "attrs": {
        "dict-type": this.dictValueType
      },
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'DICTDATA_ALL',
        delete: 'DICTDATA_DELETE'
      },
      permission: {
        query: 'system:dict-data:query',
        add: 'system:dict-data:add',
        edit: 'system:dict-data:edit',
        remove: 'system:dict-data:remove'
      },
      // [本页面特有] 当前选择的字典的值类型 1 数字 2 字符
      dictValueType: 0
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'dict_label',
        label: '字典标签',
        minWidth: '100px',
        fixed: 'left'
      }, {
        prop: 'dict_type',
        label: '标识',
        minWidth: '100px'
      }, {
        prop: 'dict_number',
        label: '字典值',
        minWidth: '100px',
        formatter: function formatter(row) {
          return row.dict_number === 0 ? '0' : row.dict_number;
        },
        show: this.dictValueType === 0 || this.dictValueType === 1
      }, {
        prop: 'dict_value',
        label: '字典值',
        minWidth: '100px',
        show: this.dictValueType === 0 || this.dictValueType === 2
      }, {
        prop: 'status',
        label: '状态',
        width: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "status",
              "value": row.status
            }
          });
        },
        show: false
      }, {
        prop: 'remark',
        label: '备注',
        width: '100px',
        show: false
      }, {
        prop: 'create_by',
        label: '创建人员',
        width: '100px',
        show: false
      }, {
        prop: 'created_at',
        label: '创建时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.created_at, 'YYYY/M/D HH:mm:ss');
        },
        show: false
      }, {
        prop: 'update_by',
        label: '更新人员',
        width: '100px',
        show: false
      }, {
        prop: 'updated_at',
        label: '更新时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.updated_at, 'YYYY/M/D HH:mm:ss');
        },
        show: false
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref2) {
        var row = _ref2.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: "\u786E\u5B9A\u5220\u9664 [ ".concat(row.dict_label, " ] \u5417"),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'dict_id',
        label: '字典名称',
        default: this.dictId,
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "dict_id",
              "custom": true,
              "all": true
            },
            "model": {
              value: _this3.search.form.model.dict_id,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "dict_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dict_label',
        label: '字典标签',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.dict_label,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "dict_label", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dict_value',
        label: '字典值',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.dict_value,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "dict_value", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        label: '状态',
        default: this.$env.VUE_APP_DICT_EMPTY_NUMBER,
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true,
              "all": true
            },
            "model": {
              value: _this3.search.form.model.status,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "status", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    dictId: function dictId() {
      return utils.helper.getNumberOrZero(this.$route.query.dict_id);
    }
  },
  methods: {
    /**
     * @description 搜索方法
     * @returns 数据
     */
    searchMethod: function searchMethod() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dictIdInSearchForm, dict, method, dictData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 获得父级字典的类型
                dictIdInSearchForm = _this4.search.form.model.dict_id;

                if (!(dictIdInSearchForm !== 0)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return _this4.$api.DICT_DETAIL(dictIdInSearchForm);

              case 4:
                dict = _context.sent;
                _this4.dictValueType = _this4._.get(dict, 'dict_value_type', 0);

              case 6:
                // 获取当前字典下的条目
                method = _this4.$api[_this4.api.index];
                _context.next = 9;
                return method(_this4.searchData);

              case 9:
                dictData = _context.sent;
                return _context.abrupt("return", dictData);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 加载需要的字典数据
     */
    loadDict: function loadDict() {
      // 字典
      this.loadDictOne({
        name: 'dict_id',
        method: this.$api.DICT_ALL,
        fields: 'dict_name,id',
        path: 'list',
        label: 'dict_name'
      });
    }
  }
};